<template>
  <div class="video-embed-wrapper">
    <div class="video-embed-container">
      <iframe
        v-if="platform === 'youtube'"
        :src="`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`"
        :title="title"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        class="video-iframe"
      ></iframe>
      <iframe
        v-else-if="platform === 'vimeo'"
        :src="`https://player.vimeo.com/video/${videoId}`"
        :title="title"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        class="video-iframe"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoEmbed",
  props: {
    videoId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "Embedded Video",
    },
    platform: {
      type: String,
      default: "youtube",
      validator: (value) => ["youtube", "vimeo"].includes(value),
    },
  },
};
</script>

<style scoped>
.video-embed-wrapper {
  margin: 2rem 0;
  padding: 0;
}

.video-embed-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .video-embed-wrapper {
    margin: 1.5rem 0;
  }

  .video-embed-container {
    border-radius: 6px;
  }
}
</style>
